/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Zdroj zobrazování PDF médií v podobě HTML iframe elementu
 * ve kterém je načtená aplikace PDF prohlížeče.
 * @implements {ViewerSource}
 */
class PdfViewerSource {
  /**
   * Vytvoří instanci.
   * @param {PdfParent} parent
   * @param {ViewerSourceIframe} sourceIframe
   */
  constructor(parent, sourceIframe) {
    this.parent = parent;
    this.sourceIframe = sourceIframe;
  }

  /** @inheritdoc */
  destroy() {
    // TODO #295 Rušit iframe zdroj a parent zde, nebo ve vyšší úrovni?
    this.parent.destroy();
    this.sourceIframe.destroy();
  }

  /** @inheritdoc */
  getEl() {
    return this.sourceIframe.getEl();
  }

  /** @inheritdoc */
  getFrame() {
    return this.sourceIframe.getFrame();
  }

  /**
   * Zjistí rodičovské API při komunikaci s přehrávačem PDF.
   * @returns {PdfParent}
   */
  getParent() {
    return this.parent;
  }

  /** @inheritdoc */
  setParentEl(parentEl) {
    return this.sourceIframe.setParentEl(parentEl);
  }
}

export default PdfViewerSource;
